module.exports = "varying vec3 vPos;\n\nvoid main () {\n  gl_FragColor = vec4(vec3(vPos), 1.0);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/components/Shaders/Simple/fs.frag
// module id = 27
// module chunks = 0